(() => {
  const mobileStickyMedia = window.matchMedia('(max-width: 749px)');
  const mobileInfoMedia = window.matchMedia('(max-width: 989px)');

  const initWisentProduct = (root) => {
    if (!root || root.dataset.wpAmazonReady === 'true') return;
    root.dataset.wpAmazonReady = 'true';

    const mainImage = root.querySelector('[data-wp-main-image]');
    const price = root.querySelector('[data-wp-price]');
    const comparePrice = root.querySelector('[data-wp-compare-price]');
    const mobilePrice = root.querySelector('[data-wp-mobile-price]');
    const sku = root.querySelector('[data-wp-sku]');
    const stock = root.querySelector('[data-wp-stock]');
    const stockText = root.querySelector('[data-wp-stock-text]');
    const variantSelect = root.querySelector('[data-wp-variant-select]');
    const submit = root.querySelector('[data-wp-submit]');
    const submitText = root.querySelector('[data-wp-submit-text]');
    const mobileAtc = root.querySelector('[data-wp-mobile-atc]');
    const mobileSubmit = root.querySelector('[data-wp-mobile-submit]');
    const mobileSubmitText = root.querySelector('[data-wp-mobile-submit-text]');
    const primaryBuy = root.querySelector('[data-wp-primary-buy]');
    const productForm = root.querySelector('product-form form');

    // Six supporting information cards are native <details> elements.
    // Keep desktop expanded; on mobile start collapsed. No content is
    // fetched or added on interaction: it is always in the HTML for SEO.
    const infoDetails = Array.from(root.querySelectorAll('[data-wp-info-details]'));
    if (infoDetails.length) {
      const syncInfoDetails = () => {
        const isMobile = mobileInfoMedia.matches;
        infoDetails.forEach((details) => {
          details.open = !isMobile;
          const summary = details.querySelector('summary');
          if (summary) {
            if (isMobile) summary.removeAttribute('tabindex');
            else summary.tabIndex = -1;
          }
        });
      };

      infoDetails.forEach((details) => {
        details.addEventListener('click', (event) => {
          if (!mobileInfoMedia.matches && event.target.closest('summary')) {
            event.preventDefault();
          }
        });
      });

      syncInfoDetails();
      mobileInfoMedia.addEventListener?.('change', syncInfoDetails);
    }

    const setMainImage = (imageUrl, srcset, alt) => {
      if (!mainImage || !imageUrl) return;
      mainImage.src = imageUrl;
      if (srcset) {
        mainImage.srcset = srcset;
      } else {
        mainImage.removeAttribute('srcset');
      }
      if (alt) mainImage.alt = alt;
    };

    const setActiveThumb = (thumb) => {
      root.querySelectorAll('[data-wp-thumb]').forEach((item) => item.classList.remove('is-active'));
      if (thumb) thumb.classList.add('is-active');
    };

    root.querySelectorAll('[data-wp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setMainImage(thumb.dataset.image, thumb.dataset.srcset, thumb.dataset.alt);
        setActiveThumb(thumb);
      });
    });

    root.querySelectorAll('[data-wp-qty]').forEach((qtyWrap) => {
      const input = qtyWrap.querySelector('[data-wp-qty-input]');
      const minus = qtyWrap.querySelector('[data-wp-qty-minus]');
      const plus = qtyWrap.querySelector('[data-wp-qty-plus]');
      if (!input) return;

      minus?.addEventListener('click', () => {
        const current = parseInt(input.value || '1', 10);
        input.value = Math.max(1, current - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus?.addEventListener('click', () => {
        const current = parseInt(input.value || '1', 10);
        input.value = Math.max(1, current + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', () => {
        const current = parseInt(input.value || '1', 10);
        input.value = Number.isFinite(current) ? Math.max(1, current) : 1;
      });
    });

    const updateButtonState = (available) => {
      const isAvailable = available === true || available === 'true';
      if (submit) {
        submit.disabled = !isAvailable;
        submit.setAttribute('aria-disabled', String(!isAvailable));
      }
      if (submitText) submitText.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
      if (mobileSubmit) mobileSubmit.disabled = !isAvailable;
      if (mobileSubmitText) mobileSubmitText.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
    };

    const updateStockState = (available) => {
      const isAvailable = available === true || available === 'true';
      if (!stock || !stockText) return;
      stock.classList.toggle('is-available', isAvailable);
      stock.classList.toggle('is-unavailable', !isAvailable);
      stockText.textContent = isAvailable
        ? (root.dataset.inStockText || 'In stock / ready to ship')
        : (root.dataset.outOfStockText || 'Call for availability');
    };

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const selected = variantSelect.selectedOptions[0];
        if (!selected) return;

        if (price && selected.dataset.price) price.textContent = selected.dataset.price;
        if (mobilePrice && selected.dataset.price) mobilePrice.textContent = selected.dataset.price;

        if (comparePrice) {
          const compareRaw = parseInt(selected.dataset.compareRaw || '0', 10);
          if (compareRaw > 0 && selected.dataset.compare) {
            comparePrice.textContent = selected.dataset.compare;
            comparePrice.classList.remove('is-hidden');
          } else {
            comparePrice.textContent = '';
            comparePrice.classList.add('is-hidden');
          }
        }

        if (sku) sku.textContent = selected.dataset.sku || '—';
        updateButtonState(selected.dataset.available);
        updateStockState(selected.dataset.available);

        if (selected.dataset.image) {
          setMainImage(selected.dataset.image, selected.dataset.srcset, selected.dataset.alt);
          const match = Array.from(root.querySelectorAll('[data-wp-thumb]')).find(
            (thumb) => thumb.dataset.image === selected.dataset.image
          );
          if (match) setActiveThumb(match);
        }

        updateMobileStickyVisibility();
      });
    }

    if (mobileSubmit && productForm) {
      mobileSubmit.addEventListener('click', () => {
        if (mobileSubmit.disabled) return;
        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit();
        } else {
          productForm.querySelector('[type="submit"]')?.click();
        }
      });
    }

    let mobileStickyRaf = null;

    const setMobileStickyVisible = (visible) => {
      if (!mobileAtc) return;
      mobileAtc.classList.toggle('is-visible', visible);
      mobileAtc.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    function updateMobileStickyVisibility() {
      if (!mobileAtc || !primaryBuy || root.dataset.mobileSticky !== 'true') {
        setMobileStickyVisible(false);
        return;
      }

      if (!mobileStickyMedia.matches || (submit && submit.disabled)) {
        setMobileStickyVisible(false);
        return;
      }


      const buyRect = primaryBuy.getBoundingClientRect();
      const hasPassedMainBuyArea = buyRect.bottom < 0;

      setMobileStickyVisible(hasPassedMainBuyArea);
    }

    const requestMobileStickyUpdate = () => {
      if (mobileStickyRaf) return;
      mobileStickyRaf = window.requestAnimationFrame(() => {
        mobileStickyRaf = null;
        updateMobileStickyVisibility();
      });
    };

    if (mobileAtc) {
      updateMobileStickyVisibility();
      window.addEventListener('scroll', requestMobileStickyUpdate, { passive: true });
      window.addEventListener('resize', requestMobileStickyUpdate);
      mobileStickyMedia.addEventListener?.('change', requestMobileStickyUpdate);
    }
  };

  const initAll = (container = document) => {
    container.querySelectorAll('[data-wp-amazon-product]').forEach(initWisentProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
